import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { restApi } from './features/api/restApiSlice';
import { restApiLegacy } from './features/api/restApiSliceLegacy';

import reducers from './reducers';

/**
 * Redux Toolkit's own default here is `devTools: true` regardless of the build,
 * so without this line the DevTools extension is live in production. That is a
 * whole-application concern rather than a feature one, and it surfaced with the
 * Cloudflare token screen (PRE-3291): a credential travels through the store as
 * a mutation argument, and the extension records every action with its full
 * payload. Removing the value from state afterwards does not remove it from that
 * recording, so the recording is what has to be off.
 */
const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: {
    ...reducers,
    [restApi.reducerPath]: restApi.reducer,
    [restApiLegacy.reducerPath]: restApiLegacy.reducer,
  },
  preloadedState: window.INITIAL_STATE,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(restApi.middleware)
      .concat(restApiLegacy.middleware),
});

setupListeners(store.dispatch);

export default store;
